import { User } from './user';

export class Grade {
  name!: string;
  description?: string;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;

  static getSortColumns() {
    return [
      'name',
      'symbol',
      'description',
      'status',
    ];
  }


  constructor(data: any) {
    this.user_uuid = data.user_uuid;
    this.name = data.name;
    this.description = data.description;
    this.status = data.status;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
